<template>
  <main id="main">
    <Transition name="fade">
      <Loader v-if="!$page" />
    </Transition>
    <template v-if="$page">
      <PageHeader :content="$page.header" />
    </template>
  </main>
</template>

<script>
import PageHeader from '@/components/sections/PageHeader.vue'
import Loader from '@/components/small/Loader.vue'
import PageMetaMixin from '@/mixins/PageMetaMixin'

export default {
  name: 'NotFound',
  mixins: [PageMetaMixin],
  beetPage: 'not_found',
  components: { Loader, PageHeader },
}
</script>
